<template>
  <AlertsParams />
  <LoaderFullPage v-if="store.loading" />
  <AlertsListing />
  <FreemiumUpgradePopup
    title="Souscrire à l'abonnement Essentiel"
    ref="freemiumUpgradePopup"
    closable
    imgUrl="/images/paywall-preview-new-digest.png"
  >
    <div class="text-centered">
      <h4 class="title-medium-semibold">Alertes</h4>
      <p>
        Créez vos propres alertes pour rester notifié en temps réel sur les
        sujets qui vous intéressent.
      </p>
    </div>
  </FreemiumUpgradePopup>
</template>

<script setup lang="ts">
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import AlertsParams from "@follaw-fr/components/alerting/organisms/AlertsParams.vue";
import AlertsListing from "@follaw-fr/components/alerting/organisms/AlertsListing.vue";
import { useAlertsStore } from "@follaw-fr/stores/alerts.js";
import FreemiumUpgradePopup from "@follaw-fr/components/reusable/atoms/FreemiumUpgradePopup.vue";
import { provide, ref } from "vue";
import { openAlertPaywallModalKey } from "@follaw-fr/constants/injection-keys";

const freemiumUpgradePopup = ref<typeof FreemiumUpgradePopup | null>(null);
const openFreemiumModal = () => {
  freemiumUpgradePopup.value?.open();
};

provide(openAlertPaywallModalKey, openFreemiumModal);

const store = useAlertsStore();
store.readAlerts();
</script>
